import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";
// api should be your axios instance that already sends Authorization + x-tenant-domain

export const fetchWaterBillReportThunk = createAsyncThunk(
  "waterBillReport/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const params = {
        from_date: filters?.from_date || "",
        to_date: filters?.to_date || "",
        ward_id: filters?.ward_id || "",
        agent_id: filters?.agent_id || "",
      };

      const res = await api.get("/api/reports/water-bill-report", { params });
      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed to load report");
      }
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const waterBillReportSlice = createSlice({
  name: "waterBillReport",
  initialState: {
    rows: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearWaterBillReport: (state) => {
      state.rows = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWaterBillReportThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWaterBillReportThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload || [];
      })
      .addCase(fetchWaterBillReportThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load report";
      });
  },
});

export const { clearWaterBillReport } = waterBillReportSlice.actions;
export default waterBillReportSlice.reducer;
